import Ajax from '@utils/ajax';

export default {
  create(data, options = {}) {
    return Ajax.post({
      url: `/groups`,
      data: { group: data },
      ...options,
    });
  },

  search(group, searchTerm, options = {}) {
    return Ajax.get({
      url: `/search`,
      data: {
        group_id: group && group.id,
        search_term: searchTerm,
      },
      ...options,
    });
  },

  fetch(userId, options = {}) {
    return Ajax.get({
      url: `/users/${userId}/groups`,
      ...options,
    });
  },

  follow(group) {
    return Ajax.post({
      url: `/groups/${group.id}/follow`,
    });
  },

  get(groupId, options = {}) {
    return Ajax.get({
      url: `/groups/${groupId}`,
      ...options,
    });
  },

  addClaps(group, count, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/add_claps`,
      data: {
        count,
      },
      ...options,
    });
  },

  passwordAccess(group, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/password_access`,
      data: data,
      ...options,
    });
  },

  possibleCoverPhotos(group, options = {}) {
    return Ajax.get({
      url: `/groups/${group.id}/possible_cover_photos`,
      ...options,
    });
  },

  quiz(group, options = {}) {
    return Ajax.get({
      url: `/groups/${group.id}/quiz`,
      ...options,
    });
  },

  answerQuiz(group, quiz, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/quizzes/${quiz.id}/answer`,
      data: data,
      ...options,
    });
  },

  finishQuiz(group, quiz, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/quizzes/${quiz.id}/mark_as_finished`,
      data: data,
      ...options,
    });
  },

  update(group, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}`,
      data: { group: data, _method: 'PATCH' },
      ...options,
    });
  },

  updateJSON(group, data, options = {}) {
    return Ajax.postJSON({
      url: `/groups/${group.id}`,
      data: { group: data, _method: 'PATCH' },
      ...options,
    });
  },

  updateRole(group, user, role) {
    return Ajax.post({
      url: `/groups/${group.id}/update_role_for_user`,
      data: {
        _method: 'PATCH',
        role: role,
        user_id: user.id,
      },
    });
  },

  duplicate(group, { addMembers = false, preservePrivacy = false }, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/duplicate`,
      data: {
        copy_users: addMembers ? '1' : null,
        copy_invites: addMembers ? '1' : null,
        copy_permissions: preservePrivacy ? '1' : null,
      },
      ...options,
    });
  },

  delete(group, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}`,
      data: {
        _method: 'DELETE',
      },
      ...options,
    });
  },

  sendNotification(group, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/notifications`,
      data: { notifications: data },
      ...options,
    });
  },

  removeUser(group, userId, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/remove_user`,
      data: {
        _method: 'DELETE',
        user_id: userId,
      },
      ...options,
    });
  },

  like(group, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/likes`,
      data: data,
      ...options,
    });
  },

  flag(group, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/flagged_recs/`,
      data: {
        flagged_rec: data,
      },
      ...options,
    });
  },
};
